import { BASE_CLASS_PREFIX } from '../base/constants';
const cssClasses = {
  PREFIX: "".concat(BASE_CLASS_PREFIX, "-tree"),
  PREFIX_OPTION: "".concat(BASE_CLASS_PREFIX, "-tree-option")
};
const strings = {
  EXPAND_ACTION: [false, 'click', 'doubleClick']
};
const numbers = {};
export { cssClasses, strings, numbers };